/**
 * StatGrid's layout, kept out of StatGrid.tsx so its skeleton can share it from
 * a module light enough for a route's `pendingComponent` (the split
 * `stat-strip-variants.ts` makes for StatStrip), and so StatGrid.tsx exports
 * only components (the Fast Refresh rule).
 */

/**
 * How many figures a row holds, by the card's own width. Never all of them
 * in one row: Price info put ten in a single StatStrip, and at the 844px
 * main column "Rs 12.19 Cr" ran into "2,44,310 kitta".
 *
 *  - `four`: Price info's 2 rows × 4 (`4236:73517`), two across on a phone.
 *  - `six`: Key numbers, the mock's one row of six on the main column (cp1,
 *    2026-10-29: 6 cards in a row at 844), threes below `@3xl`, twos on a
 *    phone. The tiles are as many as mm-be serves (six today), and a seventh
 *    simply starts the next row.
 */
export const STAT_GRID_COLUMNS = {
  four: 'grid-cols-2 @xl:grid-cols-4',
  six: 'grid-cols-2 @xl:grid-cols-3 @3xl:grid-cols-6',
} as const

export type StatGridColumns = keyof typeof STAT_GRID_COLUMNS

/**
 * Every cell draws its own top hairline and 16px either side of it; the
 * wrapper clips the first row's line and the outer padding (`-my-4`), so a
 * rule runs the card's full width between rows however many columns the
 * width allows, and nothing doubles the card's own padding at either end.
 */
export const STAT_GRID_CELL = 'border-t border-border-subtle py-4 pr-4'
